/**
 * Auth Hooks
 * Centralized exports for all auth-related React Query hooks
 */

// Query keys
export { authQueryKeys } from "./query-keys";

// Organization hooks
export {
  useOrganization,
  useCreateOrganization,
  useUpdateOrganization,
  useDeleteOrganization,
  useLeaveOrganization,
} from "./organization";

// Team hooks
export {
  useTeams,
  useTeamMembers,
  useTeamsWithMembers,
  useCreateTeam,
  useUpdateTeam,
  useDeleteTeam,
  useAddTeamMember,
  useRemoveTeamMember,
} from "./teams";

// Invitation hooks
export {
  useInvitations,
  useInviteMember,
  useCancelInvitation,
} from "./invitations";

// Member management hooks
export {
  useRemoveMember,
  useUpdateMemberRole,
} from "./members";

// Role hooks
export {
  useCustomRoles,
  useCreateCustomRole,
  useUpdateCustomRole,
  useDeleteCustomRole,
  useAssignCustomRole,
  useAssignBuiltInRole,
  useBuiltInRoles,
  useAllRoles,
} from "./roles";

// User profile hooks
export { useUpdateUser } from "./profile";

// Password management hooks
export { useChangePassword } from "./password";

// Two-Factor Authentication hooks
export {
  useEnable2FA,
  useVerifyTOTP,
  useDisable2FA,
} from "./two-factor";

// Session management hooks
export {
  useSessions,
  useRevokeSession,
  useRevokeOtherSessions,
} from "./sessions";

// Authentication hooks
export {
  useSignIn,
  useSignUp,
  useVerifyBackupCode,
  useDeleteAccount,
} from "./auth";

// Utils
export { getDefaultTeam, isDefaultTeam } from "./utils";


// Effective permissions hooks
export { useEffectiveEntityPermissions } from "./use-effective-entity-permissions";

// Conditional tab access hooks
export { useConditionalTabAccess } from "./use-conditional-tab-access";
export type { TabAccessContext, UseConditionalTabAccessResult } from "./use-conditional-tab-access";
